import React, { useEffect, useState } from "react";
import { FormBuilder } from "@formio/react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
// css
import 'formiojs/dist/formio.full.css';
import "./UpdateTemplate.css"
// custom imports
import { HandleApiError } from "../../../Utils/CommonErrors/HandleApiError";
import TemplateService from "../../../Services/TemplateService/TemplateService";
import { hideLoader, showLoader } from "../../../Redux/Slice/Loader/loaderSlice";
import showToast from "../../../Utils/Toast/ToastNotification";


const UpdateTemplate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [formJson, setFormJson] = useState(null);

  const userId = useSelector(
    state => state.auth.user.data?.body?.data?.userData?.id
  );
  const token = useSelector(
    (state) => state.auth.user.data?.body?.data?.token
  );

  const [templateData, setTemplateData] = useState({
    template_name: "",
    description: "",
    tags: [],
    form_data: {
      display: "form",
      components: [],
    },
    last_updated_by: userId,
  });

  const getTemplate = async () => {
    try {
      const params = {
        id: id
      }
      const response = await TemplateService.getTemplate(params, token)
      const template = response?.data?.body?.data?.templates[0]
      setFormJson(template.form_data);

      setTemplateData({
        template_name: template.template_name,
        description: template.description,
        // tags: template.tags.join(", "),
        tags: Array.isArray(template.tags) ? template.tags : [],
        form_data: template.form_data,
        last_updated_by: userId,
      });

    } catch (error) {
      HandleApiError(error)
    }
  }

  const handleSubmit = async () => {
    dispatch(showLoader())
    try {

      const payload = {
        ...templateData,
        tags: templateData.tags
      };

      const response = await TemplateService.updateTemplate(id, payload, token);
      if (response?.data?.statusCode === 200) {
        showToast("success", response.data.body.message);
        navigate("/template-listing");
      } else {
        showToast("error", response.data.body.message)
      }

    } catch (error) {
      HandleApiError(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTemplateData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    getTemplate()
  }, [])

  return (

    <div className="main-inner-block">
      <form onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
        <div className="content">
          <div className="d-flex align-items-center justify-content-between mb-4 block-one">
            <div className="heading-content mt-0">
              Edit Template
            </div>
          </div>

          <div className="white-box">
            <div className="d-flex gap-3 create-user-block w-100 justify-content-between">
              <div className="row m-0 w-100 justify-content-between">
                <div className="mb-3 col-md-4">
                  <label htmlFor="TemplateName" className="form-label">
                    Template Name
                  </label>
                  <input
                    type="text"
                    name="template_name"
                    className="form-control"
                    id="TemplateName"
                    placeholder="Template name"
                    value={templateData.template_name}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="mb-3 col-md-4">
                  <label htmlFor="description" className="form-label">
                    Description
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="description"
                    id="description"
                    placeholder="Template Description"
                    value={templateData.description}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="mb-3 col-md-4">
                  <label htmlFor="tag" className="form-label">
                    Tag
                  </label>
                  <div className="tag-input-wrapper">
                    {templateData.tags.map((tag, index) => (
                      <span key={index} className="tag-pill">
                        {tag}
                        <button
                          type="button"
                          className="tag-remove-btn"
                          onClick={() => {
                            const updatedTags = [...templateData.tags];
                            updatedTags.splice(index, 1);
                            setTemplateData({ ...templateData, tags: updatedTags });
                          }}
                        >
                          ×
                        </button>
                      </span>
                    ))}
                    <input
                      type="text"
                      className="tag-input"
                      placeholder="Type and press Enter"
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && e.target.value.trim()) {
                          e.preventDefault();
                          const newTag = e.target.value.trim();
                          if (!templateData.tags.includes(newTag)) {
                            setTemplateData({
                              ...templateData,
                              tags: [...templateData.tags, newTag],
                            });
                          }
                          e.target.value = "";
                        }
                      }}
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className="heading-content">Form Builder</div>
        <div className="content">
          <div className="white-box">
            {formJson ? (
              <>
                <FormBuilder
                  form={templateData.form_data}
                  onChange={(schema) => {
                    setFormJson(schema);
                    setTemplateData((prev) => ({
                      ...prev,
                      form_data: {
                        ...prev.form_data,
                        components: schema.components,
                      },
                    }));
                  }}
                />

              </>
            ) : (
              <p>No form data available</p>
            )}
          </div>


        </div>

        <div className="text-center d-flex justify-content-center button-block gap-3">
          <button
            type="button"
            className="green-btn submit-btn"
            onClick={() => navigate("/template-listing")}
          >
            Back
          </button>
          <button
            type="button"
            className="green-btn submit-btn"
            onClick={handleSubmit}
          >
            Update
          </button>
        </div>
      </form>
    </div>

  );
};

export default UpdateTemplate;
